import React, { useEffect, useState } from "react";
import { useSite } from "@/context/SiteContext";

// Mobile-only tasteful sticky book action.
export function StickyBook() {
  const { openBooking } = useSite();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`sm:hidden fixed bottom-0 left-0 right-0 z-40 p-4 transition-all duration-500 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <button
        data-testid="sticky-book-button"
        onClick={() => openBooking("mobile-sticky")}
        className="w-full bg-espresso text-ivory py-4 rounded-full text-xs uppercase tracking-[0.2em] font-medium shadow-2xl shadow-espresso/30"
      >
        Book Your Visit
      </button>
    </div>
  );
}
